import axios from 'axios';

import { getV2RootUrl, publicAxiosHeaderV2 } from 'common/helpers/apiHelper';

export const getForWeb = () => {
  const axiosHeaders = publicAxiosHeaderV2();
  const { headers } = axiosHeaders;

  return axios.get(
    `${getV2RootUrl()}/setting/for-web?version=V2&tenantId=${headers.tenantId}`
  );
};
